import http from '@/utils/http';
import i18n from '@/main';

const URL_BASE = '/dashboard';

export default {
    dashboard({
        idCultura,
        idSafra,
        idEstado,
        idFornecedor,
        idRegionalBunge,
        idGerenteRegional,
        idGerenteComercial,
        idGestorTerritorial,
        idStatus,
        idTipoContrato
    }) {
        return http.post({
            url: URL_BASE + `/buscarTotalizadoresContratosOriginacao`,
            data: {
                idCultura,
                idSafra,
                idEstado,
                idFornecedor,
                idRegionalBunge,
                idGerenteRegional,
                idGerenteComercial,
                idGestorTerritorial,
                idStatus,
                idTipoContrato
            },
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.rastreabilidadeEmpresa.dashboard.buscandoDadosRastreabilidade'
            )
        });
    },
    dashboardSubEmpresa({ idCultura, idSafra, idEstado, idFornecedor, tipoContrato, idSubTrading }) {
        return http.post({
            url: URL_BASE + `/buscarTotalizadoresContratosOriginacaoEmpresa`,
            data: {
                idCultura,
                idSafra,
                idEstado,
                idFornecedor,
                tipoContrato,
                idSubTrading
            },
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.rastreabilidadeEmpresa.dashboard.buscandoDadosRastreabilidade'
            )
        });
    },

    exportarRelatorioXlsx(dados) {
        const fileLink = document.createElement('a');
        try {
            return http
                .post({
                    url: URL_BASE + `/download`,
                    responseType: 'blob',
                    data: { ...dados },
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.preparandoDadosParaDownload'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    getRankingVolumePorCriterio({ tipoVolume, tipoCriterio }) {
        return http.get({
            url: `${URL_BASE}/ranking/volume-criterio`,
            data: { tipoVolume, tipoCriterio },
            lockScreen: false
        });
    },
    postRankingVolume(
        idCultura,
        idSafra,
        idEstado,
        idFornecedor,
        idRegionalBunge,
        idGerenteRegional,
        idGerenteComercial,
        idGestorTerritorial,
        idTipoContrato
    ) {
        return http.post({
            url: `${URL_BASE}/ranking/estados`,
            data: {
                idCultura,
                idSafra,
                idEstado,
                idFornecedor,
                idRegionalBunge,
                idGerenteRegional,
                idGerenteComercial,
                idGestorTerritorial,
                idTipoContrato
            },
            lockScreen: true
        });
    }
};
